export const environment = {
    production: false,
    apiHost: 'https://drl.cogentcore.ai/grms3',
    emailHost: 'https://drl.cogentcore.ai/email3',
    chatbotEnabled: true,
    securityEnabled: false,
    sipWsUrl: 'wss://drl.cogentcore.ai/sip-ws/',
    sipDomain: '14.192.146.177',
    stompUrl: 'https://drl.cogentcore.ai/grms-ws/',
    stunUrl: 'stun:loadboard.sigmaplexsolutions.com:3478',
    turnTcpUrl: 'turn:loadboard.sigmaplexsolutions.com:3478?transport=tcp',
    turnUsername: 'grmis',
    turnCredential: 'Turn@grmis123',
    transcriptionWorkerUrl: 'https://drl.cogentcore.ai/transcription-worker',
    transcriptionLanguage: 'ur',
    // R&D AI Call Simulator talks ONLY to the hermes-agent; the agent does STT,
    // reasoning, the Q&A memory/context store, getAnswer, GRMS and TTS itself.
    hermesAgentUrl: 'https://drl.cogentcore.ai/hermes-agent-rnd',
} as const;
